module.exports = __webpack_public_path__ + "static/media/Panorama-Domus-Sessoriana.2a79f41c.jpg";